import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';

import 'react-multi-carousel/lib/styles.css';

import { Course as ICourse } from '@/components/Courses/CoursesCard';
import Course from '@/components/Layout/Header/Search/Suggestions/Course';
import HorizontalScroll from '@/components/Layout/Header/Search/Suggestions/HorizontalScroll';

interface Props {
  courses?: ICourse[];
  onClickBook?: () => void;
}

const CourseCarousel: FC<Props> = ({ courses, onClickBook }) => {
  return (
    <HorizontalScroll scrollAmount={250} className='sm:gap-3 gap-2'>
      <AnimatePresence mode='popLayout'>
        {courses?.map((course, index) => (
          <motion.div
            key={course._id}
            layout
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
          >
            <Course onClickBook={onClickBook} course={course} key={index} />
          </motion.div>
        ))}
      </AnimatePresence>
    </HorizontalScroll>
  );
};

export default CourseCarousel;
